import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const bookingApi = {
  status: () => axios.get(`${API}/oauth/calendar/status`).then(r => r.data),
  login: () => axios.get(`${API}/oauth/calendar/login`).then(r => r.data),
  availability: (date) => axios.get(`${API}/availability`, { params: { date } }).then(r => r.data),
  book: (payload) => axios.post(`${API}/bookings`, payload).then(r => r.data),
};
